var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHoriAlignLeft24 = function SvgIconHoriAlignLeft24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65 18.5v-13h1.7v13h-1.7ZM9.5 11.15h9v1.7h-9v-1.7Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m8.736 10.948 3.173-3.023 1.173 1.23L10.096 12l2.986 2.845-1.173 1.23-3.173-3.023a1.448 1.448 0 0 1 0-2.104Zm1.17 1.234-.003.002Z",
    fill: "current"
  })));
};
export default SvgIconHoriAlignLeft24;